enum NavigationState {
    Idle = 'idle',
    Submitting = 'submitting',
    Loading = 'loading',
}

enum PathParams {
    ArtifactType = 'artifactTypeParam',
    Chain = 'chainParam',
    CollectionSlug = 'collectionSlugParam',
    CompetitionSlug = 'competitionSlugParam',
    Contract = 'contractParam',
    CryptoType = 'cryptoTypeParam',
    EidOrCartId = 'eidOrCartIdParam',
    Email = 'emailParam',
    GroupId = 'groupIdParam', //needed
    Id = 'idParam', // non-specific id, given the routing path makes sense
    InviteCode = 'inviteCodeParam',
    PartnerKey = 'partnerKeyParam',
    Slug = 'slugParam',
    WishlistSlug = 'wishlistSlugParam',
    Yat = 'yatParam',
    AuthProvider = 'authProviderParam',
}

enum RoutingSearchParams {
    Addresses = 'addresses',
    EFTransactionID = '_ef_transaction_id',
    ItemId = 'item',
    PartnerKey = 'partner',
    Yat = 'yat',
}

export { NavigationState, PathParams, RoutingSearchParams };
